import Media from "../../classes/Media";
import Playlist from "../../classes/Playlist";

export interface StateInterface {
  allUserPlaylists: Array<Playlist>;
}

function state(): StateInterface {
  return {
    allUserPlaylists: [],
  };
}

export default state;
